import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import { browserHistory } from 'react-router';
// import Moment from 'react-moment';
import Pagination from "react-js-pagination";
// import * as SVGICONS from '../../../../images/img/images';

import * as constant from '../../../../constants/constant';
import * as adminDashboardActions from '../../../../actions/admin/dashboard/admindashboardActions';
import autoBind from 'auto-bind';
// import ShowMore from 'react-show-more';
// import '../../styles/css/style.css';
import * as statisticsActions from '../../../../actions/statisticsActions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Bar, BarChart, Legend, Label, ScatterChart, Scatter, Area, AreaChart } from 'recharts';
// import { isAbsolute } from 'path';
import {
	confirmAlert
} from 'react-confirm-alert';

class ImagesDashboard extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
			specialistData: [],
			BlogsData: [],
			ApprovedspecialistData: [],
			ApprovedBlogsData: [],
			tabCLicked: 1,
			activePage: 1,
			count: "10",
			totalCountTab1: '',
			totalCountTab2: '',
			totalCountTab3: '',
			totalCountTab4: '',
			nameClicked: false,
			specialist: { SpecialistName: '', SpecialistImage: '', SpecialistId: '', },
			blog: { blogName: '', blogImage: '', blogId: '', specialistId: '', tempListImage: '' },
			Approvedspecialist: { SpecialistName: '', SpecialistImage: '', SpecialistId: '', },
			Approvedblog: { blogName: '', blogImage: '', blogId: '', specialistId: '', tempListImage: '' }

		}
		this.sortChanged = this.sortChanged.bind(this);
	}

	// searchText
	componentWillMount() {

		var data = {
			page: "1",
			count: "10",
			userId: localStorage.getItem('userId')
		}
		this.props.action.getBlogImagesForAdmin(data)
		this.props.action.getSpecialistForProfileImage(data)
		this.props.action.getSpecialistWithApprovedProfileImage(data)
		this.props.action.getBlogsWithApprovedImages(data)

	}
	componentWillReceiveProps(nextProps) {
		this.setState({
			specialistData: nextProps.specialistData && nextProps.specialistData.data ? nextProps.specialistData.data : '',
			ApprovedspecialistData: nextProps.ApprovedspecialistData && nextProps.ApprovedspecialistData.data ? nextProps.ApprovedspecialistData.data : '',
			totalCountTab1: nextProps.specialistData && nextProps.specialistData.totalCount,
			totalCountTab2: nextProps.ApprovedspecialistData && nextProps.ApprovedspecialistData.totalCount,
			totalCountTab3: nextProps.BlogsData && nextProps.BlogsData.totalCount,
			totalCountTab4: nextProps.ApprovedBlogsData && nextProps.ApprovedBlogsData.totalCount,


			BlogsData: nextProps.BlogsData && nextProps.BlogsData.data ? nextProps.BlogsData.data : '',
			ApprovedBlogsData: nextProps.ApprovedBlogsData && nextProps.ApprovedBlogsData.data ? nextProps.ApprovedBlogsData.data : '',
			updateBlogsData: nextProps.updateBlogsData,

		})
	}

	updateIsProfileImageVerified(item) {
		// debugger;
		this.setState({
			nameClicked: false
		})
		var data = {
			isNotified: false,
			userId: item.usersData._id,
			page: "1",
			count: "10",
			imageName: item.tempProfileImage
		}
		confirmAlert({
			title: 'Confirm',
			message: 'Do you wish to approve this image ?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {

						this.props.action.updateIsProfileImageVerified(data, this.state.tabCLicked)
					}
				},
				{
					label: 'cancel',
					onClick: () => { }
				}
			]
		})


	}
	updateIsProfileImageSpecialist(item) {
		// debugger;
		var data = {
			isNotified: false,
			userId: item.SpecialistId,
			page: "1",
			count: "10",
			imageName: item.tempProfileImage

		}
		confirmAlert({
			title: 'Confirm',
			message: 'Do you wish to approve this image ?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {

						this.props.action.updateIsProfileImageVerified(data, this.state.tabCLicked)
					}
				},
				{
					label: 'cancel',
					onClick: () => { }
				}
			]
		})
		// this.props.action.updateIsProfileImageVerified(data)


	}
	RejectIsProfileImageVerified(item) {
		// debugger;
		this.setState({
			nameClicked: false
		})
		var data = {
			isNotified: true,
			userId: item.usersData._id,
			page: "1",
			count: "10",
			imageName: item.tempProfileImage
		}
		confirmAlert({
			title: 'Confirm',
			message: 'Do you wish to reject this image ?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {

						this.props.action.updateIsProfileImageVerified(data, this.state.tabCLicked)
					}
				},
				{
					label: 'cancel',
					onClick: () => { }
				}
			]
		})
		// this.props.action.updateIsProfileImageVerified(data)

	}
	RejectIsProfileImageSpecialist(item) {
		// debugger;
		this.setState({
			nameClicked: false
		})
		var data = {
			isNotified: true,
			userId: item.SpecialistId,
			page: "1",
			count: "10",
			imageName: item.tempProfileImage

		}
		confirmAlert({
			title: 'Confirm',
			message: 'Do you wish to reject this image ?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {

						this.props.action.updateIsProfileImageVerified(data, this.state.tabCLicked)
					}
				},
				{
					label: 'cancel',
					onClick: () => { }
				}
			]
		})
		// this.props.action.updateIsProfileImageVerified(data)


	}
	updateIsBlogImageVerified(item) {
		// debugger;
		this.setState({
			nameClicked: false
		})
		var data = {
			isNotified: false,
			tempListImage: item.tempListImage,
			userId: item.usersData._id,
			blogId: item._id,
			page: "1",
			count: "10",
			bannerImageName: item.tempBannerImage ? item.tempBannerImage : 'awdwad'
		}
		confirmAlert({
			title: 'Confirm',
			message: 'Do you wish to approve this image ?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {

						this.props.action.updateBlogImageVerified(data, this.state.tabCLicked)
					}
				},
				{
					label: 'cancel',
					onClick: () => { }
				}
			]
		})
		// this.props.action.updateBlogImageVerified(data)

	}
	updateIsBlogImageSpecialist(item) {
		// debugger;
		var data = {
			isNotified: false,
			tempListImage: item.tempListImage,
			userId: item.specialistId,
			blogId: item.blogId,
			page: "1",
			count: "10",
			bannerImageName: item.blogImage ? item.blogImage : 'awdawd'

		}
		confirmAlert({
			title: 'Confirm',
			message: 'Do you wish to approve this image ?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {

						this.props.action.updateBlogImageVerified(data, this.state.tabCLicked)
					}
				},
				{
					label: 'cancel',
					onClick: () => { }
				}
			]
		})
		// this.props.action.updateBlogImageVerified(data)

	}
	RejectIsBlogImageVerified(item) {
		// debugger;
		this.setState({
			nameClicked: false
		})
		var data = {
			isNotified: true,
			tempListImage: item.tempListImage,
			userId: item.usersData._id,
			blogId: item._id,
			page: "1",
			count: "10",
			bannerImageName: item.tempBannerImage ? item.tempBannerImage : 'awdwad'
		}
		confirmAlert({
			title: 'Confirm',
			message: 'Do you wish to reject this image ?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {

						this.props.action.updateBlogImageVerified(data, this.state.tabCLicked)
					}
				},
				{
					label: 'cancel',
					onClick: () => { }
				}
			]
		})
		// this.props.action.updateBlogImageVerified(data)

	}
	RejectIsBlogImageSpecialist(item) {
		// debugger;
		this.setState({
			nameClicked: false
		})
		var data = {
			isNotified: true,
			tempListImage: item.tempListImage,
			userId: item.specialistId,
			blogId: item.blogId,
			page: "1",
			count: "10",
			bannerImageName: item.blogImage ? item.blogImage : 'awdawd'

		}
		confirmAlert({
			title: 'Confirm',
			message: 'Do you wish to reject this image ?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {

						this.props.action.updateBlogImageVerified(data, this.state.tabCLicked)
					}
				},
				{
					label: 'cancel',
					onClick: () => { }
				}
			]
		})
		// this.props.action.updateBlogImageVerified(data)

	}

	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
		let object = {
			page: pageNumber.toString(),
			count: this.state.count.toString(),
			userId: localStorage.getItem('userId')
		}
		if(this.state.tabCLicked == 1){
			this.props.action.getSpecialistForProfileImage(object)
		}
		else if(this.state.tabCLicked  == 2){
			this.props.action.getSpecialistWithApprovedProfileImage(object)
		}
		else if(this.state.tabCLicked  == 3){
			this.props.action.getBlogImagesForAdmin(object)
		}
		else if(this.state.tabCLicked  == 4){
			this.props.action.getBlogsWithApprovedImages(object)
		}
	}
	onChangeTab(data) {

		this.setState({
			nameClicked: false,
			tabCLicked: data,
			activePage:'1'
		});
		var obj = {
			page: "1",
			count: "10",
			userId: localStorage.getItem('userId')
		}
		if(data == 1){
			this.props.action.getSpecialistForProfileImage(obj)
		}
		else if(data == 2){
			this.props.action.getSpecialistWithApprovedProfileImage(obj)
		}
		else if(data == 3){
			this.props.action.getBlogImagesForAdmin(obj)
		}
		else if(data == 4){
			this.props.action.getBlogsWithApprovedImages(obj)
		}

	}
	sortChanged(sortColumnName, order, e) {
		e.preventDefault();
		this.state.sortColumnName = sortColumnName;
		this.state.page = 1;
		this.state.sortOrder = order == 1 ? -1 : 1;

		let userToken = localStorage.getItem('token');
		let specialistId = localStorage.getItem('userId');
		const sorting = {}
		sorting[sortColumnName] = order.toString().toLowerCase() == 1 ? -1 : 1
		this.state.sorting = sorting;
		let object = {
			page: this.state.page,
			count: this.state.count,
			userType: 'finance',
			sorting: sorting
		}
		this.props.actions.getUserList(object);
	}
	_sortClass(filterName) {
		return "fa fa-fw " + ((filterName == this.state.sortColumnName) ? ("fa-sort-" + this.state.sortOrder) : "fa-sort");
	}

	componentDidMount() {

	}
	nameClicked(index, item) {

		var state = this.state;
		if (this.state.tabCLicked == 1) {
			state.specialist.SpecialistName = item.usersData.userName,
				state.specialist.SpecialistImage = item.tempProfileImage
			state.specialist.SpecialistId = item.usersData._id
		} else if (this.state.tabCLicked == 2) {

			state.Approvedspecialist.SpecialistName = item.usersData.userName,
				state.Approvedspecialist.SpecialistImage = item.tempProfileImage
			state.Approvedspecialist.SpecialistId = item.usersData._id
		}
		else if (this.state.tabCLicked == 3) {
			state.blog.blogName = item.blogTitle,
				state.blog.blogImage = item.tempBannerImage
			state.blog.blogId = item._id,
				state.blog.specialistId = item.usersData._id
			state.blog.tempListImage = item.tempListImage
		}

		else if (this.state.tabCLicked == 4) {
			state.Approvedblog.blogName = item.blogTitle,
				state.Approvedblog.blogImage = item.tempBannerImage
			state.Approvedblog.blogId = item._id,
				state.Approvedblog.specialistId = item.usersData._id
			state.Approvedblog.tempListImage = item.tempListImage
		}
		this.setState(state);
		this.setState({
			nameClicked: !this.state.nameClicked,

		})
	}
	render() {
		if (this.state.tabCLicked == 1) {
			var specialistData = this.state.specialistData;

		}
		console.log('this.state.BlogsData', this.state.BlogsData)
		var rows = [];
		{
			this.state.tabCLicked == 1 ?
				this.state.specialistData && this.state.specialistData.length > 0 ? this.state.specialistData.forEach(
					function (item, index) {
						// var activated = item.users.isActivated == '2' ? '1' : '2'
						rows.push(
							<tr key={index}>
								<td>
									<td><img src={constant.PRODUCTION_IMAGE_URL + 'uploads/' + item.usersData._id + '/' + item.tempProfileImage} /></td>

								</td>
								<td><Link onClick={this.nameClicked.bind(this, index, item)}>{item.usersData.userName}</Link></td>
								<td>{item.usersData.gender}</td>
								<td>

									<button type="submit" className="btn btn-warning btn-lg button-btn" onClick={this.updateIsProfileImageVerified.bind(this, item)}>Approve {this.state.spinner == true ? <i className="fa fa-spinner fa-spin" /> : ""}</button>  <button type="button" onClick={this.RejectIsProfileImageVerified.bind(this, item)} className="btn btn-cancel btn-default btn-lg button-btn">Reject</button>

								</td>

							</tr>


						);
					}.bind(this)
				) : <tr><td>No Records Found</td></tr>
				: this.state.tabCLicked == 2 ?
					this.state.ApprovedspecialistData && this.state.ApprovedspecialistData.length > 0 ? this.state.ApprovedspecialistData.forEach(
						function (item, index) {
							// var activated = item.users.isActivated == '2' ? '1' : '2'
							rows.push(
								<tr key={index}>
									<td>
										<td><img src={constant.PRODUCTION_IMAGE_URL + 'uploads/' + item.usersData._id + '/' + item.tempProfileImage} /></td>

									</td>
									<td><Link onClick={this.nameClicked.bind(this, index, item)}>{item.usersData.userName}</Link></td>
									<td>{item.usersData.gender}</td>
									<td>

										<button type="button" onClick={this.RejectIsProfileImageVerified.bind(this, item)} className="btn btn-cancel btn-default btn-lg button-btn">Reject</button>

									</td>
								</tr>
								// <tr><td>No Records Found</td></tr>

							);
						}.bind(this)
					) : <tr><td>No Records Found</td></tr>
					: this.state.tabCLicked == 3 ?
						this.state.BlogsData && this.state.BlogsData.length > 0 ? this.state.BlogsData.forEach(
							function (item, index) {
								// var activated = item.users.isActivated == '2' ? '1' : '2'
								rows.push(
									<tr key={index}>
										<td>
											<td><img src={constant.PRODUCTION_IMAGE_URL + 'uploads/' + item.usersData._id + '/' + item.tempBannerImage} /></td>

										</td>
										<td><Link onClick={this.nameClicked.bind(this, index, item)}>{item.usersData.userName}</Link></td>
										<td>{item.blogTitle}</td>
										<td>

											<button type="submit" className="btn btn-warning btn-lg button-btn" onClick={this.updateIsBlogImageVerified.bind(this, item)}>Approve {this.state.spinner == true ? <i className="fa fa-spinner fa-spin" /> : ""}</button>  <button type="button" onClick={this.RejectIsBlogImageVerified.bind(this, item)} className="btn btn-cancel btn-default btn-lg button-btn">Reject</button>

										</td>

									</tr>
									// <tr><td>No Records Found</td></tr>

								);
							}.bind(this)
						) : <tr><td>No Records Found</td></tr>
						: this.state.tabCLicked == 4 ?
							this.state.ApprovedBlogsData && this.state.ApprovedBlogsData.length > 0 ? this.state.ApprovedBlogsData.forEach(
								function (item, index) {
									// var activated = item.users.isActivated == '2' ? '1' : '2'
									rows.push(
										<tr key={index}>
											<td>
												<td><img src={constant.PRODUCTION_IMAGE_URL + 'uploads/' + item.usersData._id + '/' + item.tempBannerImage} /></td>

											</td>
											<td><Link onClick={this.nameClicked.bind(this, index, item)}>{item.usersData.userName}</Link></td>
											<td>{item.blogTitle}</td>
											<td>

												<button type="button" onClick={this.RejectIsBlogImageVerified.bind(this, item)} className="btn btn-cancel btn-default btn-lg button-btn">Reject</button>

											</td>

										</tr>
										// <tr><td>No Records Found</td></tr>

									);
								}.bind(this)
							) : <tr><td>No Records Found</td></tr>
							: '';
		}
		return (

			<div className="content-wrapper">
				<section className="content container-fluid">
					<ToastContainer />
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB proCalendar">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li>

										</li>
										<li><Link className="active show" href="#tab_1" data-toggle="tab"
											onClick={this.onChangeTab.bind(this, 1)}
										>Specialist Images</Link></li>
										<li><Link href="#tab_2" data-toggle="tab"
											onClick={this.onChangeTab.bind(this, 2)}
										>Specialist Approved Images</Link></li>
										<li><Link href="#tab_3" data-toggle="tab"
											onClick={this.onChangeTab.bind(this, 3)}
										> Blog Images</Link></li>
										<li><Link href="#tab_4" data-toggle="tab"
											onClick={this.onChangeTab.bind(this, 4)}
										> Blog Approved Images</Link></li>

									</ul>

									{!this.state.nameClicked ? <div className="row">
										<div className="col-md-12">
											<div className="tab-content tabother ">
												<div className="row">
													<div className="box-body table-responsive no-padding aTable">
														<div className="table-responsive">
															<table className="table tableList imgusertable">
																<tbody>
																	{this.state.tabCLicked == 1 ? <tr>
																		<th onClick={this.sortChanged.bind(this, 'userName', this.state.sortOrder)}>
																		</th>
																		<th onClick={this.sortChanged.bind(this, 'email', this.state.sortOrder)}>Specialist Name<i className={this._sortClass('appointmentspecialistname')}></i></th>
																		<th onClick={this.sortChanged.bind(this, 'createdAt', this.state.sortOrder)}>Gender<i className={this._sortClass('appointmentspecialistname')}></i></th>
																		<th ></th>
																	</tr>
																		: this.state.tabCLicked == 2 ? <tr>
																			<th onClick={this.sortChanged.bind(this, 'userName', this.state.sortOrder)}>
																			</th>
																			<th onClick={this.sortChanged.bind(this, 'email', this.state.sortOrder)}>Specialist Name<i className={this._sortClass('appointmentspecialistname')}></i></th>
																			<th onClick={this.sortChanged.bind(this, 'createdAt', this.state.sortOrder)}>Gender<i className={this._sortClass('appointmentspecialistname')}></i></th>
																			<th ></th>
																		</tr>
																			: this.state.tabCLicked == 3 ?
																				<tr>
																					<th onClick={this.sortChanged.bind(this, 'userName', this.state.sortOrder)}>
																					</th>
																					<th onClick={this.sortChanged.bind(this, 'email', this.state.sortOrder)}>Specialist Name<i className={this._sortClass('appointmentspecialistname')}></i></th>
																					<th onClick={this.sortChanged.bind(this, 'createdAt', this.state.sortOrder)}>Blog Name<i className={this._sortClass('appointmentspecialistname')}></i></th>
																					<th ></th>
																				</tr>
																				: this.state.tabCLicked == 4 ?
																					<tr>
																						<th onClick={this.sortChanged.bind(this, 'userName', this.state.sortOrder)}>
																						</th>
																						<th onClick={this.sortChanged.bind(this, 'email', this.state.sortOrder)}>Specialist Name<i className={this._sortClass('appointmentspecialistname')}></i></th>
																						<th onClick={this.sortChanged.bind(this, 'createdAt', this.state.sortOrder)}>Blog Name<i className={this._sortClass('appointmentspecialistname')}></i></th>
																						<th ></th>
																					</tr> : ''
																	}

																	{rows && rows.length > 0 ? rows : <tr><td colSpan={4} className="text-center">No Record Found</td></tr>}
																</tbody>
															</table>
														</div></div>
												</div>
												{/* {(userListData && userListData.length > 0) ? */}
												{ this.state.tabCLicked == 1 && this.state.specialistData && this.state.specialistData.length > 0 ? (
													<div className="row">
														<div className="col-sm-5">
															<div className="showingEntries">
																Showing{" "}
																{this.state.activePage * this.state.count -
																	(this.state.count - 1)}{" "}
																to{" "}
																{this.state.activePage * this.state.count >
																	this.state.totalCountTab1
																	? this.state.totalCountTab1
																	: this.state.activePage * this.state.count}{" "}
																of {this.state.totalCountTab1} entries
                            </div>  </div>
														<div
															className="col-sm-7 text-right"
															style={{ cursor: "pointer" }}
														>
															<Pagination
																prevPageText="Prev"
																nextPageText="Next"
																hideFirstLastPages
																activePage={this.state.activePage}
																itemsCountPerPage={10}
																totalItemsCount={this.state.totalCountTab1}
																pageRangeDisplayed={10}
																onChange={this.handlePageChange.bind(this)}
															/>
														</div>
													</div>
												) : (
														""
													)}
														{ this.state.tabCLicked == 2 && this.state.ApprovedspecialistData && this.state.ApprovedspecialistData.length > 0 ? (
													<div className="row">
														<div className="col-sm-5">
															<div className="showingEntries">
																Showing{" "}
																{this.state.activePage * this.state.count -
																	(this.state.count - 1)}{" "}
																to{" "}
																{this.state.activePage * this.state.count >
																	this.state.totalCountTab2
																	? this.state.totalCountTab2
																	: this.state.activePage * this.state.count}{" "}
																of {this.state.totalCountTab2} entries
                            </div>  </div>
														<div
															className="col-sm-7 text-right"
															style={{ cursor: "pointer" }}
														>
															<Pagination
																prevPageText="Prev"
																nextPageText="Next"
																hideFirstLastPages
																activePage={this.state.activePage}
																itemsCountPerPage={10}
																totalItemsCount={this.state.totalCountTab2}
																pageRangeDisplayed={10}
																onChange={this.handlePageChange.bind(this)}
															/>
														</div>
													</div>
												) : (
														""
													)}
													{ this.state.tabCLicked == 3 && this.state.BlogsData && this.state.BlogsData.length > 0 ? (
													<div className="row">
														<div className="col-sm-5">
															<div className="showingEntries">
																Showing{" "}
																{this.state.activePage * this.state.count -
																	(this.state.count - 1)}{" "}
																to{" "}
																{this.state.activePage * this.state.count >
																	this.state.totalCountTab3
																	? this.state.totalCountTab3
																	: this.state.activePage * this.state.count}{" "}
																of {this.state.totalCountTab3} entries
                            </div>  </div>
														<div
															className="col-sm-7 text-right"
															style={{ cursor: "pointer" }}
														>
															<Pagination
																prevPageText="Prev"
																nextPageText="Next"
																hideFirstLastPages
																activePage={this.state.activePage}
																itemsCountPerPage={10}
																totalItemsCount={this.state.totalCountTab3}
																pageRangeDisplayed={10}
																onChange={this.handlePageChange.bind(this)}
															/>
														</div>
													</div>
												) : (
														""
													)}
													
													{ this.state.tabCLicked == 4 && this.state.ApprovedBlogsData && this.state.ApprovedBlogsData.length > 0 ? (
													<div className="row">
														<div className="col-sm-5">
															<div className="showingEntries">
																Showing{" "}
																{this.state.activePage * this.state.count -
																	(this.state.count - 1)}{" "}
																to{" "}
																{this.state.activePage * this.state.count >
																	this.state.totalCountTab4
																	? this.state.totalCountTab4
																	: this.state.activePage * this.state.count}{" "}
																of {this.state.totalCountTab4} entries
                            </div>  </div>
														<div
															className="col-sm-7 text-right"
															style={{ cursor: "pointer" }}
														>
															<Pagination
																prevPageText="Prev"
																nextPageText="Next"
																hideFirstLastPages
																activePage={this.state.activePage}
																itemsCountPerPage={10}
																totalItemsCount={this.state.totalCountTab4}
																pageRangeDisplayed={10}
																onChange={this.handlePageChange.bind(this)}
															/>
														</div>
													</div>
												) : (
														""
													)}
											</div>
										</div>
									</div>
										: <div>
											<div className="tab-content tabother ">
												<div className="row">
													<div className="col-md-12">
														<form className="user_Specilaist_images">

															<div className="myfeedbackList editText text-right ">
																{/* <Link onClick={this.editProfile}
																		//  disabled={this.state.disabled}
																		 >Edit</Link> */}
																<div className="row">
																	<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
																		<div className="text-center avatarSec">
																			<div className="avatr">
																				{this.state.tabCLicked == 1 ? <div className="image">
																					<img className="original" src={constant.PRODUCTION_IMAGE_URL + 'uploads/' + this.state.specialist.SpecialistId + '/' + this.state.specialist.SpecialistImage}
																						alt="" />
																					{/* <Link className="" onClick={this.deleteImage}><i className="fa fa-trash"></i></Link> */}
																				</div> : this.state.tabCLicked == 3 ?
																						<div className="image">
																							<img className="original" src={constant.PRODUCTION_IMAGE_URL + 'uploads/' + this.state.blog.specialistId + '/' + this.state.blog.blogImage}
																								alt="" />
																							{/* <Link className="" onClick={this.deleteImage}><i className="fa fa-trash"></i></Link> */}
																						</div>
																						: this.state.tabCLicked == 2 ? <div className="image">
																							<img className="original" src={constant.PRODUCTION_IMAGE_URL + 'uploads/' + this.state.Approvedspecialist.SpecialistId + '/' + this.state.Approvedspecialist.SpecialistImage}
																								alt="" />
																							{/* <Link className="" onClick={this.deleteImage}><i className="fa fa-trash"></i></Link> */}
																						</div>
																							: this.state.tabCLicked == 4 ?
																								<div className="image">
																									<img className="original" src={constant.PRODUCTION_IMAGE_URL + 'uploads/' + this.state.Approvedblog.specialistId + '/' + this.state.Approvedblog.blogImage}
																										alt="" />
																									{/* <Link className="" onClick={this.deleteImage}><i className="fa fa-trash"></i></Link> */}
																								</div> : ''
																				}

																				{/* <img src={this.state.defaultImageURL} alt="" /> */}
																				{/* <div className="editimg">
																					<input name="image" onChange={this.uploadSpecialistImage} onClick={(event) => { event.target.value = null }} type="file" style={{ "display": "none" }} id="avatSelect" />
																					<label htmlFor="avatSelect" style={{ 'cursor': 'pointer' }}>
																						<SVGICONS.SpecialistProfileSvg />

																					</label>
																				</div> */}

																			</div>
																		</div>
																	</div>
																</div>
															</div>
															{this.state.tabCLicked == 1 ? <div className="text_center">
																<p>{this.state.specialist.SpecialistName}</p>
															</div> : this.state.tabCLicked == 3 ?
																	<div className="text_center">
																		<p>{this.state.blog.blogName}</p>
																	</div>
																	: this.state.tabCLicked == 2 ? <div className="text_center">
																		<p>{this.state.Approvedspecialist.SpecialistName}</p>
																	</div>
																		: this.state.tabCLicked == 4 ? <div className="text_center">
																			<p>{this.state.Approvedblog.blogName}</p>
																		</div> : ''
															}
															<div className="text_center">
																{this.state.tabCLicked == 1 ? <td>

																	<button type="submit" className="btn btn-warning btn-lg button-btn" onClick={this.updateIsProfileImageSpecialist.bind(this, this.state.specialist)} >Approve {this.state.spinner == true ? <i className="fa fa-spinner fa-spin" /> : ""}</button>  <button type="button" onClick={this.RejectIsProfileImageSpecialist.bind(this, this.state.specialist)} className="btn btn-cancel btn-default btn-lg button-btn">Reject</button>

																</td>
																	: this.state.tabCLicked == 3 ?
																		<td>

																			<button type="submit" className="btn btn-warning btn-lg button-btn" onClick={this.updateIsBlogImageSpecialist.bind(this, this.state.blog)} >Approve {this.state.spinner == true ? <i className="fa fa-spinner fa-spin" /> : ""}</button>  <button type="button" onClick={this.RejectIsBlogImageSpecialist.bind(this, this.state.blog)} className="btn btn-cancel btn-default btn-lg button-btn">Reject</button>

																		</td>
																		: this.state.tabCLicked == 2 ? <td>

																			{/* <button type="submit" className="btn btn-warning btn-lg button-btn" onClick={this.updateIsProfileImageSpecialist.bind(this, this.state.specialist)} >Approve {this.state.spinner == true ? <i className="fa fa-spinner fa-spin" /> : ""}</button>   */}
																			<button type="button" onClick={this.RejectIsProfileImageSpecialist.bind(this, this.state.Approvedspecialist)} className="btn btn-cancel btn-default btn-lg button-btn">Reject</button>

																		</td>
																			: this.state.tabCLicked == 4 ?
																				<td>

																					{/* <button type="submit" className="btn btn-warning btn-lg button-btn" onClick={this.updateIsBlogImageSpecialist.bind(this, this.state.blog)} >Approve {this.state.spinner == true ? <i className="fa fa-spinner fa-spin" /> : ""}</button> */}
																					  <button type="button" onClick={this.RejectIsBlogImageSpecialist.bind(this, this.state.Approvedblog)} className="btn btn-cancel btn-default btn-lg button-btn">Reject</button>

																				</td>
																				: ''
																}
															</div>
														</form>
													</div>
												</div>
											</div>
										</div>}
								</div>
							</div>
						</div>
					</div>
				</section>
				<div className="Copyrightafterlogin">
					<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>

		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	// debugger;
	return {
		specialistData: state.signin.specialistData,
		ApprovedspecialistData: state.signin.ApprovedspecialistData,
		updateImageData: state.signin.updateImageData,
		BlogsData: state.signin.BlogsData,
		ApprovedBlogsData: state.signin.ApprovedBlogsData,
		updateBlogsData: state.signin.updateBlogsData
	}
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(adminDashboardActions, dispatch),
		action: bindActionCreators(statisticsActions, dispatch),

	};
}
export default connect(mapStateToProps, mapDispatchToProps)(ImagesDashboard);
